import * as mt from "./mutation-types";
import { CropsState, CropsPayload } from "./types";

export default {
  [mt.CLEANUP](state: CropsState) {
    state.cropsContext = new Map();
    state.status = '';
  },
  [mt.CROPS_REQUEST_SUCCESS](state: CropsState, { uuid, crops }: CropsPayload) {
    state.cropsContext.set(uuid, crops);
    state.cropsContext = new Map(state.cropsContext);
    state.status = "fetch:crops";
  },
};
